const updateServiceTypes = {
  toastr: 'Tipo de Serviço atualizado',
  toastr1: ' foi atualizado com sucesso',
  toastrError: 'Tipo de Serviço já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateServiceTypes;
